// IBAN italiano (27 caratteri): IT + 2 cifre di controllo + CIN (1 lettera) + ABI (5) + CAB (5) + conto (12)
const ITALIAN_IBAN = /^IT(\d{2})([A-Z])(\d{5})(\d{5})([A-Z0-9]{12})$/

export function normalizeIban(iban) {
	return (iban || '').replace(/\s+/g, '').toUpperCase()
}

// Verifica ISO 13616: prime 4 cifre in coda, lettere convertite in numeri (A=10 ... Z=35), resto mod 97 = 1
export function hasValidIbanChecksum(iban) {
	const value = normalizeIban(iban)
	if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(value)) {
		return false
	}
	const rearranged = value.slice(4) + value.slice(0, 4)
	let remainder = 0
	for (const char of rearranged) {
		const digits = /[A-Z]/.test(char) ? String(char.charCodeAt(0) - 55) : char
		for (const digit of digits) {
			remainder = (remainder * 10 + Number(digit)) % 97
		}
	}
	return remainder === 1
}

// Restituisce le parti dell'IBAN italiano oppure null se il formato non è riconosciuto
export function splitItalianIban(iban) {
	const match = normalizeIban(iban).match(ITALIAN_IBAN)
	if (!match) {
		return null
	}
	return {
		iban: match[0],
		check_digits: match[1],
		cin: match[2],
		abi: match[3],
		cab: match[4],
		bank_account: match[5],
	}
}
